import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon, BarChart3Icon, BookOpenCheckIcon, LinkedinIcon, MailIcon, MessageCircleIcon, MousePointerClickIcon, SlidersHorizontalIcon, SparklesIcon } from 'lucide-react';
interface SlideProps {
  index: number;
  total: number;
}
const KOLS = [{
  name: 'Dr. Linda Stein Gold',
  shortName: 'Stein Gold',
  image: 'https://cdn.magicpatterns.com/uploads/ps6HkGVYtSyFwcnbRi4Njr/pasted-image.png'
}, {
  name: 'Dr. Raj Chovatiya',
  shortName: 'Chovatiya',
  image: 'https://cdn.magicpatterns.com/uploads/iLegRZ3zR98E1YeHyrRLPR/pasted-image.png'
}, {
  name: 'Prof. Swen Malte John',
  shortName: 'John',
  image: 'https://cdn.magicpatterns.com/uploads/5KheWsyKZQcUBHm8B2kq9A/pasted-image.png'
}, {
  name: 'Prof. Ana María Giménez-Arnau',
  shortName: 'Giménez-Arnau',
  image: 'https://cdn.magicpatterns.com/uploads/4G5yRarKD4Zo4ZrzxB1WYh/pasted-image.png'
}, {
  name: 'Prof. Xue Chen',
  shortName: 'Chen',
  image: 'https://cdn.magicpatterns.com/uploads/chCdXr9hjMrZocGJRGX2hW/pasted-image.png'
}];
const CHANNELS = [{
  icon: LinkedinIcon,
  label: 'Social'
}, {
  icon: MailIcon,
  label: 'Email'
}, {
  icon: MessageCircleIcon,
  label: 'Messaging'
}];
function FlowArrow({
  muted = false
}: {
  muted?: boolean;
}) {
  return <span className={`flex flex-shrink-0 items-center gap-1 ${muted ? 'text-black/25' : 'text-[var(--brand-green-lighter)]'}`} aria-hidden="true" data-id="element-175" data-mp="1brz6qa49vj9u">
      <span className="hidden h-px w-4 bg-current xl:block" data-id="element-176" data-mp="1gsn55gutz2e3" />
      <ArrowRightIcon className="h-4 w-4" data-id="element-177" data-mp="1kqubrivkynbk" />
    </span>;
}
export function SlideTeaserCampaign({
  index
}: SlideProps) {
  return <div className="relative flex h-screen w-screen flex-col overflow-hidden bg-[var(--bg)] px-[clamp(2rem,4vw,4rem)] pb-[clamp(2.5rem,4vh,3.5rem)] pt-[clamp(1.75rem,3vw,3rem)]" data-id="element-178" data-mp="1pp49a04s200c">
      <motion.header initial={{
      opacity: 0,
      y: 18
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      delay: 0.15,
      duration: 0.55
    }} className="mb-[clamp(1rem,1.6vw,1.5rem)] flex items-end justify-between gap-8" data-id="element-179" data-mp="314sx0tpuv327">
        <div data-id="element-180" data-mp="1b33oo9ucq720">
          <p className="mb-2 text-[clamp(0.75rem,1vw,0.95rem)] font-semibold uppercase tracking-[0.18em] text-[var(--brand-green)]" data-id="element-181" data-mp="1b1ivanjrwu5q">
            3. Optional KOL Teaser Snaks
          </p>
          <h2 className="max-w-5xl text-[clamp(2rem,3.3vw,2.85rem)] font-bold leading-[1.06] text-[var(--fg)]" data-id="element-182" data-mp="id4wi5kv1tt4">
            From one direct hook to a{' '}
            <span className="text-[var(--brand-green-light)]" data-id="element-183" data-mp="dcqp8pr32nw5">
              test-and-learn engagement engine.
            </span>
          </h2>
        </div>
        <div className="hidden flex-shrink-0 text-right lg:block" data-id="element-184" data-mp="nbyadz427mtt">
          <span className="inline-flex rounded-full bg-[var(--brand-green)] px-4 py-2 text-sm font-bold text-white shadow-sm" data-id="element-185" data-mp="3vsjeb1hu3pq2">
            Optional · 2,000€ each
          </span>
          <p className="mt-2 text-xs font-medium text-[var(--muted)]" data-id="element-186" data-mp="3qrvm4chvd2u9">
            Select any combination of KOLs
          </p>
        </div>
      </motion.header>

      <div className="flex min-h-0 flex-1 flex-col gap-[clamp(0.8rem,1.35vw,1.2rem)]" data-id="element-187" data-mp="2b35r7k860sek">
        {/* Without teaser */}
        <motion.section initial={{
        opacity: 0,
        x: -18
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        delay: 0.28,
        duration: 0.55
      }} aria-labelledby="without-teaser" className="grid flex-shrink-0 grid-cols-[11rem_1fr] overflow-hidden rounded-2xl border border-black/10 bg-[var(--surface)]" data-id="element-188" data-mp="1xctxjgvxmllb">
          <div className="flex flex-col justify-center border-r border-black/10 px-5 py-4" data-id="element-189" data-mp="2g2a2cgenh07j">
            <span className="mb-1 text-[0.68rem] font-bold uppercase tracking-[0.16em] text-[var(--muted)]" data-id="element-190" data-mp="2l0240253k0ox">
              Direct route
            </span>
            <h3 id="without-teaser" className="text-lg font-bold text-[var(--fg)]" data-id="element-191" data-mp="14oenl8rnqtgu">
              Without a teaser
            </h3>
            <p className="mt-1 text-xs leading-snug text-[var(--muted)]" data-id="element-192" data-mp="1ourzxithq7o9">
              One message asks for the full commitment.
            </p>
          </div>

          <div className="flex min-w-0 items-center gap-[clamp(0.45rem,0.9vw,0.9rem)] px-[clamp(1rem,1.8vw,1.8rem)] py-4" data-id="element-193" data-mp="1k30j4004zgbb">
            <div className="flex flex-shrink-0 items-center gap-1.5" data-id="element-194" data-mp="1b3n7b0ojifnf">
              {CHANNELS.slice(0, 2).map(channel => {
              const Icon = channel.icon;
              return <span key={channel.label} className="inline-flex items-center gap-1.5 rounded-full border border-black/10 bg-white px-2.5 py-1.5 text-xs font-semibold text-[var(--fg)]" data-id="element-195" data-mp="27rjnw5jz9ayn">
                    <Icon className="h-3.5 w-3.5 text-[var(--muted)]" data-id="element-196" data-mp="1tt3bpz3cis94" />
                    {channel.label}
                  </span>;
            })}
            </div>
            <FlowArrow muted data-id="element-197" data-mp="ieq13vxls9b1" />
            <div className="min-w-0 rounded-xl border border-black/10 bg-white px-3 py-2" data-id="element-198" data-mp="idem0zypjf4m">
              <p className="text-[0.62rem] font-bold uppercase tracking-wider text-[var(--muted)]" data-id="element-199" data-mp="2u3mdxnjhrvty">
                One generic hook
              </p>
              <p className="truncate text-sm font-semibold text-[var(--fg)]" data-id="element-200" data-mp="33316csj7ygh3">
                “Watch the DERMX webinar”
              </p>
            </div>
            <FlowArrow muted data-id="element-201" data-mp="37var7u5h8qci" />
            <div className="flex min-w-0 flex-1 items-center gap-3 rounded-xl border border-black/10 bg-white px-3 py-2" data-id="element-202" data-mp="37vkkbqltjdmf">
              <BookOpenCheckIcon className="h-5 w-5 flex-shrink-0 text-[var(--muted)]" data-id="element-203" data-mp="3hrnmgwgo7c9d" />
              <div className="min-w-0" data-id="element-204" data-mp="3mr0edvmef9it">
                <p className="text-[0.62rem] font-bold uppercase tracking-wider text-[var(--muted)]" data-id="element-205" data-mp="3msbk40zemrck">
                  Full destination
                </p>
                <p className="truncate text-sm font-semibold text-[var(--fg)]" data-id="element-206" data-mp="1sczagwbzrwbv">
                  Evergreen Webinar Snak
                </p>
              </div>
            </div>
            <div className="hidden max-w-[13rem] flex-shrink-0 xl:block" data-id="element-207" data-mp="1wgnh9cssunw2">
              <p className="text-xs font-semibold leading-snug text-[var(--muted)]" data-id="element-208" data-mp="2zq084f60in7o">
                Limited insight into which expert, topic or message created interest.
              </p>
            </div>
          </div>
        </motion.section>

        {/* With teaser */}
        <motion.section initial={{
        opacity: 0,
        x: 18
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        delay: 0.4,
        duration: 0.6
      }} aria-labelledby="with-teaser" className="grid min-h-0 flex-1 grid-cols-[11rem_1fr] overflow-hidden rounded-2xl bg-[var(--brand-green)] shadow-xl" data-id="element-209" data-mp="34obg0kcqynn9">
          <div className="flex flex-col justify-center border-r border-white/15 px-5 py-5 text-white" data-id="element-210" data-mp="3sdchtor2r0jk">
            <span className="mb-1 text-[0.68rem] font-bold uppercase tracking-[0.16em] text-[var(--brand-green-lighter)]" data-id="element-211" data-mp="3nh5oqwjs1jj1">
              Optimized route
            </span>
            <h3 id="with-teaser" className="text-lg font-bold" data-id="element-212" data-mp="bo3t7lywta1">
              With KOL teasers
            </h3>
            <p className="mt-1 text-xs leading-snug text-white/65" data-id="element-213" data-mp="jwocdhyoxcxl">
              Test what earns attention before asking for the full commitment.
            </p>
          </div>

          <div className="flex min-h-0 flex-col px-[clamp(1rem,1.7vw,1.6rem)] py-[clamp(0.9rem,1.4vw,1.3rem)]" data-id="element-214" data-mp="auf5r36jm3ph">
            {/* Main optimized flow */}
            <div className="grid min-h-0 flex-1 grid-cols-[0.7fr_auto_1.1fr_auto_1.55fr_auto_0.85fr] items-center gap-[clamp(0.35rem,0.7vw,0.7rem)]" data-id="element-215" data-mp="15ngj2sv9xi9">
              <div className="min-w-0" data-id="element-216" data-mp="5x5inu6mm44t">
                <p className="mb-2 text-[0.62rem] font-bold uppercase tracking-wider text-[var(--brand-green-lighter)]" data-id="element-217" data-mp="5y6va33aiyon">
                  1 · Channels
                </p>
                <div className="space-y-1.5" data-id="element-218" data-mp="3schws7w578jx">
                  {CHANNELS.map(channel => {
                  const Icon = channel.icon;
                  return <div key={channel.label} className="flex items-center gap-2 rounded-lg bg-white/10 px-2.5 py-2 text-xs font-semibold text-white" data-id="element-219" data-mp="3ja8j595kuz2b">
                        <Icon className="h-3.5 w-3.5" data-id="element-220" data-mp="3tuq65cp575tl" />
                        {channel.label}
                      </div>;
                })}
                </div>
              </div>

              <FlowArrow data-id="element-221" data-mp="3kt8uc6irpqap" />

              <div className="min-w-0 rounded-xl bg-white/10 p-3" data-id="element-222" data-mp="3fufe46c3jl6u">
                <div className="mb-2 flex items-center gap-2" data-id="element-223" data-mp="3fvqhw65jksxy">
                  <SlidersHorizontalIcon className="h-4 w-4 text-[var(--brand-green-lighter)]" data-id="element-224" data-mp="3b3fgeyv5kz3a" />
                  <p className="text-[0.62rem] font-bold uppercase tracking-wider text-[var(--brand-green-lighter)]" data-id="element-225" data-mp="363uk6w7db4u9">
                    2 · Test channel hooks
                  </p>
                </div>
                <div className="space-y-1.5" data-id="element-226" data-mp="2x47j6bijw11q">
                  <p className="rounded-md bg-white/10 px-2 py-1.5 text-[0.7rem] font-medium text-white" data-id="element-227" data-mp="2x60mbgtyg34z">
                    “Why is CHE so complex?”
                  </p>
                  <p className="rounded-md bg-white/10 px-2 py-1.5 text-[0.7rem] font-medium text-white" data-id="element-228" data-mp="17makg2tr8io2">
                    “Which pathways matter?”
                  </p>
                  <p className="rounded-md bg-white/10 px-2 py-1.5 text-[0.7rem] font-medium text-white" data-id="element-229" data-mp="1gn8scw7bdabx">
                    “What works day to day?”
                  </p>
                </div>
              </div>

              <FlowArrow data-id="element-230" data-mp="oxcf08szwydz" />

              <div className="min-w-0" data-id="element-231" data-mp="oy5j120kl9sf">
                <div className="mb-2 flex items-center justify-between gap-2" data-id="element-232" data-mp="sxef4dj31jr5">
                  <p className="text-[0.62rem] font-bold uppercase tracking-wider text-[var(--brand-green-lighter)]" data-id="element-233" data-mp="xwzeuq62tw4x">
                    3 · KOL teaser variants
                  </p>
                  <span className="text-[0.6rem] font-semibold text-white/55" data-id="element-234" data-mp="12psjzf5gj6hj">
                    15–30 sec
                  </span>
                </div>
                <div className="grid grid-cols-5 gap-1.5" data-id="element-235" data-mp="a6d6syw2obux">
                  {KOLS.map(kol => <div key={kol.name} className="min-w-0 rounded-lg bg-white/10 p-1.5" data-id="element-236" data-mp="bjtu9ot0beuk">
                      <div className="mb-1.5 flex h-10 items-center justify-center overflow-hidden rounded-md bg-[#E4F0EC]" data-id="element-237" data-mp="flp45hp070jy">
                        <img src={kol.image} alt={kol.name} className="h-full w-full object-contain" data-id="element-238" data-mp="km33mbcjh26d" />
                      </div>
                      <p className="truncate text-center text-[0.58rem] font-bold text-white" data-id="element-239" data-mp="3o0fkey04gx8f">
                        {kol.shortName}
                      </p>
                    </div>)}
                </div>
                <div className="mt-2 flex items-center justify-center gap-1 text-[0.65rem] font-semibold text-white/75" data-id="element-240" data-mp="6mah6s81p847">
                  <MousePointerClickIcon className="h-3.5 w-3.5" data-id="element-241" data-mp="35ar70isbdzgt" />
                  Tracked teaser click
                </div>
              </div>

              <FlowArrow data-id="element-242" data-mp="3a8iwz79efbid" />

              <div className="min-w-0 rounded-xl bg-white p-3 text-[var(--fg)] shadow-sm" data-id="element-243" data-mp="32rw2xzu0ywm3">
                <div className="mb-2 flex items-center gap-2" data-id="element-244" data-mp="2xsj8aswwwl8y">
                  <BookOpenCheckIcon className="h-4 w-4 text-[var(--brand-green)]" data-id="element-245" data-mp="2xq6qcfr5mavw" />
                  <p className="text-[0.62rem] font-bold uppercase tracking-wider text-[var(--brand-green)]" data-id="element-246" data-mp="2srlsuo3ae5b5">
                    4 · Evergreen Snak
                  </p>
                </div>
                <p className="text-sm font-bold leading-tight" data-id="element-247" data-mp="2ju1mj0qkhito">
                  Opens at the matching KOL chapter
                </p>
                <div className="mt-2 space-y-1" data-id="element-248" data-mp="2ezxhwo4rxmvr">
                  <div className="h-1.5 w-full rounded-full bg-[var(--brand-green)]" data-id="element-249" data-mp="2a3qfh5bl6tik" />
                  <div className="h-1.5 w-3/4 rounded-full bg-[var(--brand-green-lighter)]" data-id="element-250" data-mp="254dms3y1as82" />
                  <div className="h-1.5 w-1/2 rounded-full bg-black/10" data-id="element-251" data-mp="204r6tmqtmxvk" />
                </div>
              </div>
            </div>

            {/* Feedback loop */}
            <div className="mt-3 flex items-center justify-between gap-4 border-t border-white/15 pt-3" data-id="element-252" data-mp="1w5a3ozyvactk">
              <div className="flex items-center gap-2 text-white" data-id="element-253" data-mp="1qgvpvrqpr1w7">
                <SparklesIcon className="h-4 w-4 text-[var(--brand-green-lighter)]" data-id="element-254" data-mp="1qi6uftrzgdod" />
                <p className="text-xs font-semibold" data-id="element-255" data-mp="1cioxus8g3w4g">
                  More relevant entry points increase the likelihood of webinar engagement.
                </p>
              </div>
              <div className="flex items-center gap-2 rounded-full bg-white/10 px-3 py-1.5 text-white" data-id="element-256" data-mp="256un9sag29am">
                <BarChart3Icon className="h-4 w-4 text-[var(--brand-green-lighter)]" data-id="element-257" data-mp="2963eoqi0hv30" />
                <p className="text-[0.68rem] font-semibold" data-id="element-258" data-mp="1vex86agbex6m">
                  Brand learns which KOL + message + topic drives interest
                </p>
              </div>
            </div>
          </div>
        </motion.section>
      </div>

      <motion.footer initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 0.9,
      duration: 0.5
    }} className="mt-[clamp(0.8rem,1.2vw,1.1rem)] flex items-center justify-between gap-6" data-id="element-259" data-mp="2o2kohdajz1ng">
        <p className="text-[clamp(0.88rem,1.05vw,1.05rem)] font-semibold text-[var(--fg)]" data-id="element-260" data-mp="2y943bg75xm84">
          Traffic flows in through tested hooks; topic-level audience-interest signals flow back to the brand.
        </p>
        <span className="hidden flex-shrink-0 rounded-full border border-[var(--brand-green)] px-4 py-2 text-sm font-bold text-[var(--brand-green)] md:inline-flex" data-id="element-261" data-mp="371xjrgycirnk">
          Channel → message → KOL teaser → chapter → insight
        </span>
      </motion.footer>
    </div>;
}